var map = {
	"./AdobeStock_288622149.png": "3caa",
	"./Ellipse1.png": "54dc",
	"./Ellipse2.png": "2bcc",
	"./Ellipse3.png": "fb9b",
	"./Ellipse4.png": "9b4c",
	"./Ellipse5.png": "ae2b",
	"./exercises.png": "adaf",
	"./logo.png": "cf05",
	"./rsz_gradient_linear.png": "98bd",
	"./spritesheet.png": "3179",
	"./tutorials.png": "6b8e",
	"./userGuide.png": "d1a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";